import moment from 'moment'
import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllEventsOpening } from '_redux/modules/event'
import { EVENT_STATUS_OPEN } from '_utils/constant'
import useViewMode, { VIEW_MODES } from '_hooks/useViewMode'
// import useShowNotification from '_hooks/useShowNotification'
import useBodyClass from '_hooks/useBodyClass'
import EventCard from '_components/EventCard'
import useShortEvent from './hooks/useShortEvent'
import SwitchViewEvent from './components/SwitchViewEvent'
import SearchBar from './components/SearchBar'
import './style.scss'

const EventList = () => {
  useBodyClass('event-list-page')
  const dispatch = useDispatch()
  const [searchString, setSearchString] = useState('')
  const { allEvents, loadingAllEventsOpening } = useSelector((state) => state.event)
  const { viewMode, changeViewMode } = useViewMode({
    storageKey: 'event_list_view_mode',
    initialMode: VIEW_MODES.LIST,
  })
  // const { checkNotification, ShowPopup } = useShowNotification()

  const onChangeSearch = (event) => {
    setSearchString(event.target.value)
  }

  // useEffect(() => {
  //   checkNotification()
  // }, [])

  useEffect(() => {
    dispatch(getAllEventsOpening)
  }, [])

  const filteredEvents = useMemo(
    () => (allEvents || [])
      .filter((item) => item.closingTimestamp > moment().unix())
      .filter((item) => item.status === EVENT_STATUS_OPEN)
      .filter((val) => {
        if (!searchString.trim()) {
          return true
        }
        return val.title?.toLowerCase().includes(searchString.trim().toLowerCase())
      }),
    [allEvents, searchString],
  )

  const { sortKey, handleSelectSort, sortedEvents } = useShortEvent(filteredEvents)

  return (
    <div className='row-top event-page'>
      <SwitchViewEvent
        view={viewMode}
        onChange={changeViewMode}
        totalEvents={sortedEvents.length}
        currentSort={sortKey}
        onSelectSort={handleSelectSort}
      />
      <SearchBar searchString={searchString} onChange={onChangeSearch} />
      {!loadingAllEventsOpening && !sortedEvents.length ? (
        <div className='text-center mt-3' style={{ fontSize: '13px' }}>
          <p>Not Found Events Are Opening</p>
        </div>
      ) : (
        <div className={`event-list-item event-list-item--${viewMode}`}>
          {loadingAllEventsOpening && <div>Loading...</div>}
          {sortedEvents.map((event) => (
            <EventCard event={event} key={event.id} viewMode={viewMode} />
          ))}
        </div>
      )}
      {/* {ShowPopup} */}
    </div>
  )
}

export default EventList
